import React, { FunctionComponent } from 'react';

import Modal from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/Modal';
import { ModePrevModel } from '../../PrevMedia';
import { DeleteImage } from '../DeleteImage/DeleteImage';
import { EditTitleImage } from '../EditTitleImage/EditTitleImage';

interface ModalButtonListProps {
    mode: ModePrevModel;
    onHideModal: () => void;
    deleteImage: () => void;
    renameImage: (fileName: string) => void;
}

export const ModalButtonList: FunctionComponent<ModalButtonListProps> = ({
    mode,
    onHideModal,
    renameImage,
    deleteImage,
}) => {
    const mappingModal = {
        delete: (
            <DeleteImage
                isShow={mode === 'delete'}
                onHideModal={onHideModal}
                deleteImage={deleteImage}
            />
        ),
        edit: (
            <EditTitleImage
                isShow={mode === 'edit'}
                onHideModal={onHideModal}
                renameImage={renameImage}
            />
        ),
    };
    return (
        <Modal isOpen={!!mode} onHideModal={onHideModal}>
            {mappingModal[mode]}
        </Modal>
    );
};
